import { Breakpoint, ButtonType, UiComponentSize } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { DataLayerAddToCartWrapper } from 'src/components/data-layer-wrapper/data-layer-add-to-cart-wrapper';
import { Link } from 'src/components/link';
import { config } from 'src/config';
import { i18n } from 'src/i18n';
import { createOrderActionCreator } from 'src/state/order/action-creators/create-order-action-creator';
import { selectSelectedProductOrThrow } from 'src/state/order/selectors';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { I18nUtils } from 'src/utils/i18n-utils';

import { DeliveryInformation } from './delivery-information';
import { PaymentInformation } from './payment-information';
import { ProductInformation } from './product-information';
import { StyledButton, StyledContainer, StyledHeading, StyledTerms } from './summary.styled';

const SummaryPage: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const selectedProduct = useAppSelector(selectSelectedProductOrThrow);
  const { pricing } = selectedProduct;

  return (
    <DataLayerAddToCartWrapper product={selectedProduct}>
      <StyledContainer>
        <StyledHeading component="h1" variant="headline2">
          {i18n.page.summary.title}
        </StyledHeading>
        <ProductInformation />
        <PaymentInformation />
        {pricing.deliveryRequired && <DeliveryInformation />}
        <StyledButton
          buttonType={ButtonType.PRIMARY_A}
          uiComponentSize={UiComponentSize.LARGE}
          onClick={() => dispatch(createOrderActionCreator())}
        >
          {i18n.page.summary.confirmButton}
        </StyledButton>
        <StyledTerms component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
          {I18nUtils.richMessage(i18n.page.summary.termsNotes, {
            linkToTerms: (
              <Link href={config.TERMS_LINK_URL} variant="paragraph3" target="_blank" maxBreakpoint={Breakpoint.TABLET}>
                {i18n.page.summary.termsLinkText}
              </Link>
            ),
          })}
        </StyledTerms>
      </StyledContainer>
    </DataLayerAddToCartWrapper>
  );
};

export { SummaryPage };
